/**
 * Call direction
 */
const CallDirection = {
  unknown: -1,
  incoming: 0,
  outgoing: 1,
}

exports.CallDirection = CallDirection